export default "__VITE_ASSET__d167a50d__"